<div class="search-box" [hidden]="searchMode !== 'passthrough'">
    <mat-form-field class="example-form-field">
        <mat-label>{{searchBoxPlaceholder}}</mat-label>
        <span matPrefix>
            <mat-icon>
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10.9766 10.3931C12.0481 9.17035 12.6022 7.579 12.5219 5.95527C12.4416 4.33153 11.7333 2.80259 10.5465 1.69148C9.35966 0.580377 7.78739 -0.0258643 6.16184 0.000846621C4.53629 0.0275576 2.98479 0.685129 1.83514 1.83463C0.685486 2.98413 0.0277359 4.53551 0.000857258 6.16101C-0.0260214 7.78651 0.580077 9.3588 1.69109 10.5457C2.80211 11.7326 4.33102 12.4411 5.9548 12.5215C7.57858 12.6019 9.17003 12.048 10.3929 10.9767L14.2958 14.8795C14.3733 14.9568 14.4782 15.0001 14.5876 15C14.6969 14.9999 14.8018 14.9564 14.8791 14.8791C14.9564 14.8018 14.9999 14.6969 15 14.5876C15.0001 14.4782 14.9568 14.3733 14.8796 14.2959L10.9766 10.3931ZM6.27481 11.704C5.20098 11.704 4.15127 11.3856 3.25842 10.789C2.36557 10.1925 1.66968 9.34453 1.25875 8.35247C0.847822 7.36042 0.740307 6.26879 0.949803 5.21563C1.1593 4.16247 1.6764 3.19508 2.43571 2.4358C3.19502 1.67651 4.16244 1.15943 5.21563 0.94995C6.26882 0.740466 7.36048 0.847983 8.35256 1.25891C9.34465 1.66983 10.1926 2.3657 10.7892 3.25853C11.3858 4.15136 11.7042 5.20104 11.7042 6.27483C11.7025 7.71423 11.13 9.09421 10.1121 10.112C9.09427 11.1298 7.71425 11.7024 6.27481 11.704Z"
                        fill="white" />
                </svg>
            </mat-icon>
        </span>
        <input matInput type="text" #searchBox [(ngModel)]="searchValue" [ngModelOptions]="{ standalone: true }"
            (keyup.enter)="onNodesSearch(searchBox.value)" [disabled]="!treeData" class="node-search"
            autocomplete="off">
        <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)="onClearSearch()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
</div>

<div class="tree-container"
    [ngClass]="{ 'nodes-tree-offset-no-search': searchMode === 'none' || searchMode === 'native', 'nodes-tree-offset-search': searchMode === 'passthrough' }">
    <p-tree (onNodeExpand)="expandAndCollapse(CExpandStatus.Expand, $event.node)"
        (onNodeCollapse)="expandAndCollapse(CExpandStatus.Collapse, $event.node)" [value]="dataSource"
        selectionMode="single" [(selection)]="selectedNode" [filter]="searchBox === 'native'"
        (onNodeSelect)="loadMore($event.node)" (onNodeSelect)="selectedNodeChange.emit($event.node)"
        scrollHeight="600px">
        <ng-template let-node pTemplate="metric">
            <app-metric-tree-item [node]="node" (metricActionTriggered)="metricActionTriggered.emit($event)">
            </app-metric-tree-item>
        </ng-template>
        <ng-template let-node pTemplate="default">
            <span class="group-container">
                <app-connection-icon *ngIf="node.nodeType !== TreeNodeTypes.GROUP && treeType === 'group'"
                class="status-icon" [isConnected]="node.status">
            </app-connection-icon>
            <b class="m-l-5">{{ node.data?.groupValue?.path ? node.data?.groupValue?.path + "/" + node.label : node.label }}</b>
            </span>
        </ng-template>
    </p-tree>
</div>